import React, { createContext, useContext, useEffect } from 'react';

import { useKeycloak } from '@react-keycloak/web';
import Pessoa from 'model/pessoa/Pessoa';
import { KeycloakTokenParsed } from 'keycloak-js';
import { CachePessoas } from 'store/Pessoas/CachePessoas';

export interface IdTokenParsed extends KeycloakTokenParsed {
  id_institucional: string
  name: string
}

export interface UsuarioLogadoContextProps {
  usuarioLogado: Pessoa
}
  
export const UsuarioLogadoContext = createContext<UsuarioLogadoContextProps>({usuarioLogado: {idInstitucional: "", nome: ""}});

export const UsuarioLogadoProvider: React.FunctionComponent = (props) => {
  const {keycloak} = useKeycloak()
  const idTokenParsed = keycloak.idTokenParsed as IdTokenParsed
  
  const providerValue = (idTokenParsed !== undefined)
    ? {usuarioLogado: {idInstitucional: idTokenParsed.id_institucional, nome: idTokenParsed.name}}
    : {usuarioLogado: {idInstitucional: "", nome: ""}};

  useEffect(() => {
    if (idTokenParsed !== undefined) {
      CachePessoas.instance.add(providerValue.usuarioLogado);
    }
  });

  return (
    <UsuarioLogadoContext.Provider value={providerValue}>
      {props.children}
    </UsuarioLogadoContext.Provider>
  ); 
}

export const useUsuarioLogado = () => {
  return useContext(UsuarioLogadoContext).usuarioLogado
}

export default UsuarioLogadoProvider;